<div class="row mt-2">
    <div class="col-md-3">
      <div class="card">
          <div class="card-header">
              <div class="card-title mb-0"><strong>Banner</strong></div>
          </div>
          <div class="card-body">
              <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="code" class="form-label">Title <em>*</em></label>
                            <input type="text" class="form-control" id="title" name="title" #title="ngModel" [(ngModel)]="data.title" required>
                            <div *ngIf="f.submitted && title.invalid" class="invalid-feedback">
                                <div *ngIf="title.errors.required">Title is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="code" class="form-label">Image <em>*</em></label>
                            <input type="file" class="form-control" id="image" name="image" (change)="loadFile($event)">
                            <div *ngIf="f.submitted && !data.image" class="invalid-feedback">
                                <div>Image is required</div>
                            </div>
                            <div *ngIf="data.image">
                                <img [src]="data.image" class="w-100" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="mobile_image" class="form-label">Mobile Image</label>
                            <input type="file" class="form-control" id="mobile_image" name="mobile_image" (change)="loadFile($event)">
                            
                            <div *ngIf="data.mobile_image">
                                <img [src]="data.mobile_image" class="w-100" />
                            </div>
                        </div>
                    </div>
                </div>
                  <div class="row">
                      <div class="col-12">
                          <div class="mb-3">
                              <label for="status" class="form-label">Status <em>*</em></label>
                              <select class="form-control" id="status" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                                  <option [value]="1">Active</option>
                                  <option [value]="0">Disabled</option>
                              </select>
                              <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                                  <div *ngIf="status.errors.required">Status is required</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <button type="submit" class="btn btn-primary">Update</button>
              </form>
          </div>
      </div>
    </div>
  </div>